"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ymdToDate = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
exports.ymdToDate = (year, month, day) => year && month && day
    ? dayjs_1.default(new Date(parseInt(year, 10), parseInt(month, 10), parseInt(day, 10)))
    : dayjs_1.default();
//# sourceMappingURL=ymdToDate.js.map